/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetDashboardSecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type GetDashboardRequest = {
  /**
   * The dashboard to get
   */
  id: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type GetDashboardSecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const GetDashboardSecurity$outboundSchema: z.ZodMiniType<
  GetDashboardSecurity$Outbound,
  GetDashboardSecurity
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function getDashboardSecurityToJSON(
  getDashboardSecurity: GetDashboardSecurity,
): string {
  return JSON.stringify(
    GetDashboardSecurity$outboundSchema.parse(getDashboardSecurity),
  );
}

/** @internal */
export type GetDashboardRequest$Outbound = {
  id: string;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const GetDashboardRequest$outboundSchema: z.ZodMiniType<
  GetDashboardRequest$Outbound,
  GetDashboardRequest
> = z.pipe(
  z.object({
    id: z.string(),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
    });
  }),
);

export function getDashboardRequestToJSON(
  getDashboardRequest: GetDashboardRequest,
): string {
  return JSON.stringify(
    GetDashboardRequest$outboundSchema.parse(getDashboardRequest),
  );
}
